import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	palette: {
		primary: {
			main: '#D9D9D9',
		}, secondary: {
			main: '#898584',
		},
		background: {
			default: '#fafafb',
		},
		admin: {
			main: '#93FF50',
			light: '#93FF50',
			dark: '#93FF50',
			contrastText: '#000000',
		},
	},
	typography: {
		fontFamily: 'Open Sans',
		
		h3: {
			fontSize: '1.6rem',
			fontWeight: 'bold',
		},
		body2: {
			fontSize: '0.75rem',
		},
	},
	overrides: {
	}
});

export default theme;